import React from 'react';
import { Link } from 'react-router-dom';
import { Palmtree, Mountain, Waves, Bird } from 'lucide-react';

const LOGO_URL = 'https://customer-assets-gfyr7b9c.emergentagent.net/job_7012c185-728e-48dd-a634-a866967c4d91/artifacts/4wto96o3_Indo_Travel_25pct_size.png';

export const BrandStory = () => {
  const philosophyElements = [
    {
      icon: <Palmtree size={32} />,
      title: 'Palm',
      subtitle: 'Tropical Indonesia',
      description: 'Warm, welcoming landscapes full of life across thousands of islands.'
    },
    {
      icon: <Mountain size={32} />,
      title: 'Volcano',
      subtitle: 'The Ring of Fire',
      description: 'Power, energy and extraordinary geological landscapes shaped by earth itself.'
    },
    {
      icon: <Waves size={32} />,
      title: 'Waves',
      subtitle: 'A Maritime Paradise',
      description: 'An archipelago blessed with extraordinary beaches, reefs and marine biodiversity.'
    },
    {
      icon: <Bird size={32} />,
      title: 'Garuda',
      subtitle: 'The Spirit of Indonesia',
      description: 'Strength, dignity and the commitment to proudly share Indonesia with the world.'
    }
  ];

  return (
    <section className="section-padding" style={{ 
      background: 'var(--bg-primary)',
      padding: '100px 0'
    }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '60px', maxWidth: '800px', margin: '0 auto 60px' }}>
          <h2 className="hero-medium" style={{ marginBottom: '20px' }}>
            There Are Stories Behind Every Journey.
          </h2>
          <p className="body-large" style={{ 
            color: 'var(--text-secondary)', 
            marginBottom: '32px',
            fontStyle: 'italic'
          }}>
            And there is a philosophy behind every symbol.
          </p>
          <img 
            src={LOGO_URL} 
            alt="Indotravelista" 
            style={{
              height: '100px',
              width: 'auto',
              margin: '0 auto 32px',
              display: 'block'
            }}
          />
          <p className="body-regular" style={{ 
            color: 'var(--text-secondary)',
            lineHeight: 1.7
          }}>
            The Indotravelista logo represents more than a travel business. It represents how we believe Indonesia should be experienced: with meaning, discovery, and a sense of wonder.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          gap: '40px',
          marginBottom: '60px'
        }}>
          {philosophyElements.map((element, index) => (
            <div 
              key={`philosophy-${element.title}`}
              style={{
                textAlign: 'center',
                padding: '32px 24px'
              }}
            >
              <div style={{
                color: 'var(--text-primary)',
                marginBottom: '20px',
                display: 'flex',
                justifyContent: 'center'
              }}>
                {element.icon}
              </div>
              <h3 style={{
                fontSize: '20px',
                fontWeight: 600,
                marginBottom: '8px',
                color: 'var(--text-primary)'
              }}>
                {element.title}
              </h3>
              <p style={{
                fontSize: '14px',
                fontWeight: 600,
                color: 'var(--text-secondary)',
                marginBottom: '12px',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}>
                {element.subtitle}
              </p>
              <p className="body-small" style={{
                color: 'var(--text-secondary)',
                lineHeight: 1.6
              }}>
                {element.description}
              </p>
            </div>
          ))}
        </div>

        <div style={{
          textAlign: 'center',
          padding: '40px 32px',
          background: 'var(--bg-secondary)',
          borderRadius: 0,
          maxWidth: '700px',
          margin: '0 auto'
        }}>
          <p style={{
            fontSize: '16px',
            color: 'var(--text-primary)',
            marginBottom: '4px',
            fontWeight: 600,
            letterSpacing: '2px',
            textTransform: 'uppercase'
          }}>
            INDOTRAVELISTA
          </p>
          <p style={{
            fontSize: '28px',
            fontFamily: "'Crimson Text', serif",
            fontWeight: 400,
            color: 'var(--text-primary)',
            fontStyle: 'italic',
            marginBottom: '24px'
          }}>
            Live the Journey.
          </p>
          <Link 
            to="/about"
            className="btn-primary"
            style={{
              display: 'inline-block',
              textDecoration: 'none'
            }}
          >
            Discover Our Story
          </Link>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .philosophy-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};
